export default __webpack_public_path__ + "static/media/chooseLangModalBC2.d3b91016.png";